Auth = require 'app/scripts/db/auth'
Backbone = require 'app/scripts/lib/backbone'
Board = require 'app/scripts/models/board'
Card = require 'app/scripts/models/card'
Controller = require 'app/scripts/controller'
EventsMixin = require 'app/scripts/lib/events-mixin'
Organization = require 'app/scripts/models/organization'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
rpc = require 'app/scripts/network/rpc'
_ = require 'underscore'
alertSyncErrors = require 'app/scripts/network/alert-sync-errors'

setEqual = (a, b) -> a.length == b.length == _.union(a, b).length

class BoundedUniqueQueue
  constructor: (@maxLength) ->
    @contents = []

  pushift: (x) ->
    @contents = _.without(@contents, x)
    @contents.push(x)
    if @contents.length > @maxLength
      @contents.shift()
    else
      null

  remove: (x) ->
    @contents = _.without(@contents, x)

  map: (f) ->
    @contents.map(f)

getMySubscriptions = ->
  if Auth.isLoggedIn()
    [
      modelType: 'Member'
      idModel: Auth.myId()
      tags: ['messages', 'updates']
    ]
  else
    []

getOrgSubscriptions = (org) ->
  [
    modelType: 'Organization'
    idModel: org.id
    tags: ['allActions', 'updates']
  ]

getBoardSubscriptions = (board) ->
  [
    modelType: 'Board'
    idModel: board.id
    tags: ['clientActions', 'updates']
  ].concat if (org = board.getOrganization())?
    getOrgSubscriptions(org)
  else
    []

getCardSubscriptions = (card) ->
  [
    modelType: 'Board'
    idModel: card.get('idBoard')
    tags: ['clientActions', 'updates']
  ]

mixin EventsMixin, class Subscriber
  _.extend @prototype, Backbone.Events

  constructor: ->
    @boards = new BoundedUniqueQueue(5)
    @orgs = new BoundedUniqueQueue(1)
    @cards = new BoundedUniqueQueue(1)
    @custom = []

  addModel: (model) ->
    @waitForId model, =>
      if model instanceof Board
        @syncBoard(model)
      if model instanceof Organization
        @syncOrg(model)
      if model instanceof Card
        @syncCard(model)

      @ensureSubscriptions()
    return

  addCustom: (entry) ->
    @custom.push(entry)
    @ensureSubscriptions()

    =>
      @custom = @custom.filter((existing) => existing != entry)
      @ensureSubscriptions()

  removeModel: (model) ->
    if model instanceof Board
      @boards.remove(model)
    if model instanceof Organization
      @orgs.remove(model)
    if model instanceof Card
      @cards.remove(model)

    @ensureSubscriptions()

  syncBoard: (board) ->
    if (evictedBoard = @boards.pushift(board))?
      @stopListening evictedBoard

    @listenTo board, 'change:idOrganization', @ensureSubscriptions
    @listenTo board, 'destroy deleting', => @removeModel(board)
    return

  syncOrg: (org) ->
    @orgs.pushift(org)
    @listenTo org, 'destroy', => @removeModel(org)
    return

  syncCard: (card) ->
    @cards.pushift(card)

    @listenTo card, 'change:idBoard', @ensureSubscriptions
    @listenTo card, 'destroy deleting', => @removeModel(card)

  ensureSubscriptions: ->
    desiredSubscriptions = _.flatten [
      getMySubscriptions()
      @boards.map(getBoardSubscriptions)
      @orgs.map(getOrgSubscriptions)
      @cards.map(getCardSubscriptions)
      @custom
    ]

    subscriptionMap = {}
    for { modelType, idModel, tags } in desiredSubscriptions
      subscriptionMap[idModel] ?=
        tags: []
        modelType: modelType
      subscriptionMap[idModel].tags.push(tags...)
      subscriptionMap[idModel].tags = _.uniq(subscriptionMap[idModel].tags)

    # Unsubscribe from any models we don't care about anymore
    for idModel, { modelType } of rpc.currentSubscriptions when !subscriptionMap[idModel]?
      rpc.unsubscribe(modelType, idModel)

    # Unsubscribe from any models that we want to change tags on
    for idModel, { tags: subscribedTags, modelType } of rpc.currentSubscriptions when subscriptionMap[idModel]?
      desiredTags = subscriptionMap[idModel].tags
      if !setEqual(subscribedTags, desiredTags)
        rpc.unsubscribe(modelType, idModel)

    # Subscribe to all models we aren't already subscribed to
    for idModel, { tags, modelType } of subscriptionMap when !rpc.currentSubscriptions[idModel]?
      rpc.subscribe(modelType, idModel, tags)

    return

subscriber = new Subscriber()

Controller.currentModel.subscribe (model) ->
  if model?
    subscriber.addModel model
  else
    subscriber.ensureSubscriptions()
  return

alertSyncErrors()

module.exports = (spec) ->
  subscriber.addCustom(spec)
